import axios from "axios";

// const baseURL = "http://172.26.5.104:7373";
const baseURL = "/fayda/api/";

const secondURL = "https://apps.hijradigital.com/fayda/second/verification";


export const ApiService = {

    fetchCustomerInfo: async (loadCustomer) => {
        try {
            const res = await axios.post(`${baseURL}/auth/customerInfo`, loadCustomer);
            return res.data;
        }catch (error) {
            throw error;
        }
    },

    sendOtp: async (account) => {
        try {
            const res = await axios.get(`${secondURL}/request-otp?accountNumber=${account}`);
            return res.data;
        }catch (error) {
            throw error;
        }

    },

    fetchAuthorizationUrl: async (loadCustomer) => {
        try {
            const res = await axios.post(`${secondURL}`, loadCustomer);
            return res.data;
        }catch (error) {
            throw error;
        }
    },
}